import {StringObject} from '@shared/interfaces/objects.interface';

export const FormErrorMessagesMapper: StringObject = {
  email: 'Niepoprawny format adresu e-mail.',
  required: 'To pole jest wymagane.',
  isArrayLimitExceed: 'Wybrano zbyt wiele elementów.',
  minlength: 'Wybrano zbyt mało elementów.',
  maxlength: 'Wybrano zbyt wiele elementów.',
  min: 'Wprowadzono zbyt niską wartość',
  max: 'Wprowadzono zbyt wysoką wartość',
};
